<h1 mat-dialog-title>Draft</h1>
<div mat-dialog-content>
    <p>Would you like to save this claim as a draft before exiting?</p>
</div>
<div mat-dialog-actions>
    <button mat-raised-button class="action-button" (click)="onYesClick()">Yes</button>
    <button mat-raised-button (click)="onCancelClick()">No</button>
</div>